export const FETCH_LOAD_ALL_SUGGESTED_USERS_REQUEST = 'FETCH_LOAD_ALL_SUGGESTED_USERS_REQUEST'
export const FETCH_LOAD_ALL_SUGGESTED_USERS_SUCCESS = 'FETCH_LOAD_ALL_SUGGESTED_USERS_SUCCESS'
export const FETCH_LOAD_ALL_SUGGESTED_USERS_FALUIRE = 'FETCH_LOAD_ALL_SUGGESTED_USERS_FALUIRE'
